import { FC, SyntheticEvent, useEffect, useState } from "react";
import SectionHeader from "../Layout/SectionHeader";

import classes from "./Topics.module.css";
import TabPanel from "@mui/material/Tabs";
import { Badge, Tab, Tabs } from "@mui/material";
import { userState } from "../../store/user";
import { useSelector } from "react-redux";
import axios from "axios";
import { TopicModelDocument } from "../votes/Vote";
import ActiveTopic from "./ActiveTopic";
import ArchivedTopic from "./ArchivedTopic";
import AnnouncedTopic from "./AnnouncedTopic";
import { getLang, i18n } from "../../i18n";

const Topics: FC = () => {
  const lang = getLang();
  const t = i18n.quizzes[lang];

  const [value, setValue] = useState("active");
  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const [screenIsLoading, setScreenIsLoading] = useState(true);
  const [announcedTopics, setAnnouncedTopics] = useState<TopicModelDocument[]>(
    []
  );
  const [activeTopics, setActiveTopics] = useState<TopicModelDocument[]>([]);
  const [archivedTopics, setArchivedTopics] = useState<TopicModelDocument[]>(
    []
  );
  const handleTabChange = (
    e: SyntheticEvent<Element, Event>,
    tabIndex: any
  ) => {
    window.scrollTo({
      top: 31,
      behavior: "smooth",
    });
    setValue(tabIndex);
  };
  useEffect(() => {
    console.log("topics use effect");
    const getUserTopics = async () => {
      await axios
        .get(`${API_URL}/topics/list`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          console.log(response.data);
          setAnnouncedTopics(response.data.data.announcedTopics);
          setActiveTopics(response.data.data.activeTopics);
          setArchivedTopics(response.data.data.archivedTopics);
          setScreenIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setScreenIsLoading(false);
        });
    };

    getUserTopics();
  }, []);

  console.log(announcedTopics);

  return (
    <>
      <SectionHeader label={t.label} />
      {!screenIsLoading && (
        <section className={classes.battles}>
          <Tabs
            variant="fullWidth"
            value={value}
            onChange={handleTabChange}
            className={classes.tabs}
          >
            <Tab
              value="announced"
              label={
                <Badge
                  badgeContent={
                    announcedTopics.length === 0 ? "0" : announcedTopics.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  {t.tabs.announced}
                </Badge>
              }
            />
            <Tab
              value="active"
              label={
                <Badge
                  badgeContent={
                    activeTopics.length === 0 ? "0" : activeTopics.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  {t.tabs.active}
                </Badge>
              }
            />
            <Tab
              value="archived"
              label={
                <Badge
                  badgeContent={
                    archivedTopics.length === 0 ? "0" : archivedTopics.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  {t.tabs.archived}
                </Badge>
              }
            />
          </Tabs>

          {/* Archived */}
          {value === "archived" && (
            <TabPanel value="archived">
              <div className="container">
                {archivedTopics.length > 0 ? (
                  <div className={classes.list}>
                    {archivedTopics.map((topic) => (
                      <ArchivedTopic
                        key={topic._id}
                        topicID={topic._id}
                        title={topic.title}
                        question={topic.question}
                        sponsor={topic.sponsor}
                        andTags={topic.andTags}
                        orTags={topic.orTags}
                        createdAt={topic.createdAt}
                        updatedAt={topic.updatedAt}
                        battlesCount={topic.battlesCount}
                        artworksCount={topic.artworksCount}
                      />
                    ))}
                  </div>
                ) : (
                  <div className={classes.empty}>{t.empty.archived}</div>
                )}
              </div>
            </TabPanel>
          )}

          {/* Active */}
          {value === "active" && (
            <TabPanel value="active">
              <div className="container">
                {activeTopics.length > 0 ? (
                  <div className={classes.list}>
                    {activeTopics.map((topic) => (
                      <ActiveTopic
                        key={topic._id}
                        topicID={topic._id}
                        title={topic.title}
                        question={topic.question}
                        sponsor={topic.sponsor}
                        andTags={topic.andTags}
                        orTags={topic.orTags}
                        createdAt={topic.createdAt}
                        updatedAt={topic.updatedAt}
                        battlesCount={topic.battlesCount}
                        artworksCount={topic.artworksCount}
                      />
                    ))}
                  </div>
                ) : (
                  <div className={classes.empty}>{t.empty.active}</div>
                )}
              </div>
            </TabPanel>
          )}

          {/* Announced */}
          {value === "announced" && (
            <TabPanel value="announced">
              <div className="container">
                {announcedTopics.length > 0 ? (
                  <div className={classes.list}>
                    {announcedTopics.map((topic) => (
                      <AnnouncedTopic
                        key={topic._id}
                        topicID={topic._id}
                        title={topic.title}
                        question={topic.question}
                        sponsor={topic.sponsor}
                        andTags={topic.andTags}
                        orTags={topic.orTags}
                        createdAt={topic.createdAt}
                        updatedAt={topic.updatedAt}
                      />
                    ))}
                  </div>
                ) : (
                  <div className={classes.empty}>{t.empty.announced}</div>
                )}
              </div>
            </TabPanel>
          )}
        </section>
      )}
    </>
  );
};

export default Topics;
